import { Resource, createInstance, i18n, TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next/initReactI18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import i18nConfig from '../i18nConfig'
import { dictionaryService } from './dictionaries/dictionaryService'
import { withSportTerminology } from './dictionaries/sportTerminology'
import { OrganisationSportType } from 'lib/organisation-sport'

// This function should be used inside server components to have access to
// translation function `t`
export default async function initTranslations(
    lang: string,
    i18nInstance?: i18n,
    resources?: Resource,
    sportType?: OrganisationSportType
) {
    i18nInstance = i18nInstance || createInstance()

    i18nInstance.use(initReactI18next)

    if (!resources) {
        i18nInstance.use(
            resourcesToBackend(async (language: string) =>
                withSportTerminology(await dictionaryService.getDictionary(language), sportType)
            )
        )
    }

    const translatedResources =
        resources && sportType === 'cue_sports'
            ? Object.fromEntries(
                  await Promise.all(
                      Object.entries(resources).map(async ([language, namespaces]) => {
                          const dictionary = await dictionaryService.getDictionary(language)
                          return [
                              language,
                              Object.fromEntries(
                                  Object.entries(namespaces).map(([namespace, values]) => [
                                      namespace,
                                      namespace === 'translation'
                                          ? withSportTerminology(
                                                {
                                                    ...(typeof values === 'object' && values !== null ? values : {}),
                                                    cueAssociations: dictionary.cueAssociations
                                                } as Localication,
                                                sportType
                                            )
                                          : values
                                  ])
                              )
                          ]
                      })
                  )
              )
            : resources

    await i18nInstance.init({
        lng: lang,
        resources: translatedResources,
        fallbackLng: i18nConfig.defaultLocale,
        supportedLngs: i18nConfig.locales,
        preload: resources ? [] : i18nConfig.locales
    })

    return {
        i18n: i18nInstance,
        resources: i18nInstance.services.resourceStore.data,
        t: i18nInstance.t as TFunction
    }
}
